const { CONFIG = 'staging' } = process.env;
module.exports = require('./' + CONFIG);
